import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/Toast';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ReportFormPage from './pages/ReportFormPage';
import ConfirmationPage from './pages/ConfirmationPage';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import AuthTestPage from './pages/AuthTestPage';
import FileViewerTestPage from './pages/FileViewerTestPage';
import NotFoundPage from './pages/NotFoundPage';
import { testApiConnection } from './testConnection';

function App() {
  const [apiStatus, setApiStatus] = useState({ checked: false, connected: false });

  useEffect(() => {
    const checkApiConnection = async () => {
      try {
        const result = await testApiConnection();
        setApiStatus({ checked: true, connected: result.success });
        console.log('API connection status:', result.success ? 'Connected' : 'Failed');
      } catch (error) {
        console.error('Error checking API connection:', error);
        setApiStatus({ checked: true, connected: false });
      }
    };

    checkApiConnection();
  }, []);

  return (
    <AuthProvider>
      <ToastProvider>
        {apiStatus.checked && !apiStatus.connected && (
          <div className="bg-red-600 text-white text-center py-2 px-4">
            Warning: Cannot connect to the API server. Some features may not work properly.
          </div>
        )}
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="report" element={<ReportFormPage />} />
            <Route path="confirmation/:referenceId" element={<ConfirmationPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="auth-test" element={<AuthTestPage />} />
            <Route path="file-viewer-test" element={<FileViewerTestPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
